const SUPPORT_DOMAIN = "https://learn.showit.com";
const HelpConstants = {
  SUPPORT_DOMAIN,
  URL_DOMAIN_CONFIG: `${SUPPORT_DOMAIN}/en/articles/390271-how-to-connect-your-domain-to-showit-via-dns-records`,
  URL_BLOG_CONFIG: `${SUPPORT_DOMAIN}/building-your-blog/blog-basics/request-a-blog-setup-or-migration`,
  IONOS_URL: "https://ionos.com/",
  URL_BLOG_SEO_CONFIG: `${SUPPORT_DOMAIN}/articles/3082371-showit-blog-seo`,
  URL_BLOG_SETUP: `${SUPPORT_DOMAIN}/launching-your-site/pre-launch/estimated-turnaround-times-for-launch`,
  COLUMN_PLACEHOLDER_TEXT:
    "Column options are disabled when a WordPress placeholder option is set in the text properties panel",
  WP_CUSTOM_PAGE_TEMPLATES: `${SUPPORT_DOMAIN}/en/articles/7829622-create-a-wordpress-global-template`,
  WP_TEMPLATE_HEIRARCHY: "https://developer.wordpress.org/themes/basics/template-hierarchy/",
  PUBLISH_ERROR: `${SUPPORT_DOMAIN}/en/articles/7321633-publish-error-troubleshooting`,
  GOOGLE_ANALYTICS: `${SUPPORT_DOMAIN}/en/articles/446201-set-up-google-analytics-on-your-site`,
  BDOW: `${SUPPORT_DOMAIN}/en/articles/8725816-pop-ups-forms`,
  SITE_CANVAS_SET: `${SUPPORT_DOMAIN}/en/articles/8196626-site-canvas-sets`,
  META_PIXEL: `${SUPPORT_DOMAIN}/en/articles/5188319-meta-pixel-and-conversion-api`,
  GTM: `${SUPPORT_DOMAIN}/en/articles/5611399-google-tag-manager`,
  LAUNCH_COUNTDOWN_TIMER: `${SUPPORT_DOMAIN}/en/articles/11511778-launch-challenge`,
  URL_GROUP_CHILD_ELEMENT_ANIMATIONS: `${SUPPORT_DOMAIN}/en/articles/12326164-element-grouping`,
  TUTORIAL_VIDEO_URL:
    "https://player.vimeo.com/video/1193300132?h=46cb7d5f17&badge=0&autopause=0&player_id=0&app_id=58479&play_button_position=center&pip=0",
};

export default HelpConstants;
